// extracted by mini-css-extract-plugin
module.exports = {"player":"player_player__lXuK3"};